import { apolloClient } from "@/plugins/vue-apollo.js";

const updateBlock = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/blocks/update_block.graphql"),
      variables: variables,
      
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/blocks/block_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        let allBlocks = store.readQuery(query);
        // debugger
        const findIndex = allBlocks.getBlocks.blocks.findIndex(
          (item) => item._id === data.updateBlock._id
        );
        findIndex !== -1 &&
          allBlocks.getBlocks.blocks.splice(
            findIndex,
            1,
            data.updateBlock
          );
        store.writeQuery({
          ...query,
          data: allBlocks,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateBlock };
